import { useGeoCountry } from '@/utils/useGeoCountry'

export const useUKAccess = () => {
  const { geoCountry } = useGeoCountry()
  if (geoCountry && ['GB', 'GBR'].includes(geoCountry)) {
    return true
  }
  return false
}
